/**
 * RevenueCat SDK key for iOS
 *
 * @type string
 */
export const REVENUECAT_SDK_KEY_IOS = process.env.VUE_APP_REVENUECAT_SDK_KEY_IOS || '';

/**
 * RevenueCat SDK key for Android
 *
 * @type string
 */
export const REVENUECAT_SDK_KEY_ANDROID = process.env.VUE_APP_REVENUECAT_SDK_KEY_ANDROID || '';

/**
 * RevenueCat SDK key for Testing
 *
 * @type string
 */
export const REVENUECAT_SDK_KEY_TEST = process.env.VUE_APP_REVENUECAT_SDK_KEY_TEST || '';
